import { ArrowRight, Package, ShieldCheck, Zap, Truck, BadgePercent, Headphones } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const staticProducts = [{
  id: 1,
  title: "Rock Wool Sandwich Panels",
  category: "Insulation",
  specs: "Density: 100kg/m³ | Fire Class: A1",
  price: "On Request",
  image: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-14_18_44-1.png?v=8ked7dt97z",
  srcset: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-14_18_44-1.png?v=rw2h90a2hb-wvc-srcset",
  sizes: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-14_18_44-1.png?v=j62aaattfu-wvc-sizes",
  link: "/RockWoolSandwichPanelsPage"
}, {
  id: 2,
  title: "PU Sandwich Panels",
  category: "Insulation",
  specs: "Core: Polyurethane | Thermal: 0.022 W/mK",
  price: "On Request",
  image: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-14_56_38.png?v=k6hacj0cnj",
  srcset: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-14_56_38.png?v=7r2c8p1t8rn-wvc-srcset",
  sizes: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-14_56_38.png?v=kj8zb98hn5a-wvc-sizes",
  link: "/PUSandwichPanelsPage"
}, {
  id: 3,
  title: "Trapezoidal Roofing & Wall Sheets",
  category: "Roofing",
  specs: "Thickness: 0.5mm | Profile: T-35",
  price: "On Request",
  image: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-14_59_57.png?v=foapb45fp6",
  srcset: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-14_59_57.png?v=yyzc2kdqir-wvc-srcset",
  sizes: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-14_59_57.png?v=8wlk3g25zpf-wvc-sizes",
  link: "/TrapezoidalRoofingWallSheetsPage"
}, {
  id: 4,
  title: "PPGI Steel Coils",
  category: "Steel",
  specs: "Coating: PE 25µm | Width: 1250mm",
  price: "On Request",
  image: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-15_10_05.png?v=gzmv73c03go",
  srcset: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-15_10_05.png?v=f4turr2di8a-wvc-srcset",
  sizes: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-15_10_05.png?v=etgz276mgrd-wvc-sizes",
  link: "/PPGISteelCoilsPage"
}, {
  id: 5,
  title: "Fiberglass Facade Mesh",
  category: "Facade",
  specs: "Weight: 160g/m² | Mesh: 4x4mm",
  price: "On Request",
  image: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-15_13_13.png?v=okxtg376t4t",
  srcset: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-15_13_13.png?v=t4moj3k8sqo-wvc-srcset",
  sizes: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-15_13_13.png?v=e4ml8wean7v-wvc-sizes",
  link: "/FiberglassFacadeMeshPage"
}, {
  id: 6,
  title: "Decorative Interior Wall Panels",
  category: "Interior",
  specs: "Material: Wood-Plastic | Finish: Ribbed",
  price: "On Request",
  image: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-15_17_14.png?v=f6ds0fvtui",
  srcset: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-15_17_14.png?v=sfa0rnj1oa-wvc-srcset",
  sizes: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-15_17_14.png?v=9kvhpekqx6a-wvc-sizes",
  link: "/DecorativeInteriorWallPanelsPage"
}, {
  id: 7,
  title: "Galvanized Steel Coils",
  category: "Steel",
  specs: "Zinc: 275g/m² | Grade: DX51D",
  price: "On Request",
  image: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-15_19_06.png?v=y6sw3jqczjr",
  srcset: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-15_19_06.png?v=sm794ll4tm-wvc-srcset",
  sizes: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-15_19_06.png?v=tlmfg2v3b3-wvc-sizes",
  link: "/GalvanizedSteelCoilsPage"
}, {
  id: 8,
  title: "Complete Steel Buildings & Structures",
  category: "STEEL",
  specs: "Custom Engineering | Eurocode Compliant",
  price: "On Request",
  image: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-14_24_57-1.png?v=p3w3mmqf96",
  srcset: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-14_24_57-1.png?v=2wlvqxrr83-wvc-srcset",
  sizes: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-2.-Juli-2026-14_24_57-1.png?v=i7bzw68pgon-wvc-sizes",
  link: "/AluminiumFacadeBalconySystemsPage"
}];
export default function ProductCatalogGrid() {
  return <section data-section-id="product-catalog-grid" id="productcataloggrid" className="relative bg-white py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{
      backgroundImage: 'radial-gradient(circle, #000 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} />

      <div className="container relative mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 lg:mb-24 items-end">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="font-mono text-xs font-bold tracking-[0.3em] text-primary uppercase">
                § 02 / Materials
              </span>
              <div className="h-px flex-1 bg-border" />
            </div>
            <h2 className="font-sans font-bold text-4xl md:text-5xl lg:text-6xl leading-[1.1] text-foreground tracking-tighter">
              Structural solutions, <br />
              <span className="text-primary">engineered for precision.</span>
            </h2>
          </div>

          <div className="lg:col-span-5 lg:pl-12">
            <p className="font-sans text-lg leading-relaxed text-muted-foreground mb-8 border-l-2 border-primary/20 pl-6">
              Sourced directly from certified manufacturers — high-performance materials and reliable supply for large-scale industrial projects.
            </p>
            <Link to="/ProductsPage" className="group inline-flex items-center gap-3 font-mono text-xs font-bold tracking-widest uppercase text-foreground hover:text-primary transition-colors">
              <span>Explore Full Catalog</span>
              <div className="flex items-center justify-center size-8 border border-border group-hover:border-primary group-hover:bg-primary group-hover:text-white transition-all rounded-lg shadow-sm">
                <ArrowRight className="size-4" />
              </div>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-0 border-t border-l border-border">
          {staticProducts.map((product, i) => <article key={product.id} data-index={i} className="group flex flex-col border-r border-b border-border bg-white transition-all hover:bg-muted/5">
              <Link to={product.link} className="relative aspect-square overflow-hidden block">
                <img src={product.image} data-wvc-srcset={product.srcset} data-wvc-sizes={product.sizes} alt={product.title} loading="lazy" decoding="async" className="h-full w-full object-cover grayscale hover:grayscale-0 transition-all duration-500 group-hover:scale-105" />
                <div className="absolute top-4 left-4">
                  <span className="bg-white px-2 py-1 font-mono text-[10px] font-bold tracking-tighter border border-border rounded-lg">
                    REF: {String(product.id).padStart(4, "0")}
                  </span>
                </div>
              </Link>

              <div className="flex flex-1 flex-col p-8">
                <div className="mb-4 flex items-center gap-2">
                  <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
                    [{product.category}]
                  </span>
                </div>

                <Link to={product.link} className="mb-6 block flex-1">
                  <h3 className="font-sans text-xl font-bold leading-tight text-foreground group-hover:text-primary transition-colors uppercase tracking-tight">
                    {product.title}
                  </h3>
                  <p className="mt-2 text-xs text-gray-500 font-mono">
                    {product.specs}
                  </p>
                </Link>

                <div className="mt-auto space-y-6">
                  <div className="flex items-baseline justify-between border-t border-border pt-6">
                    <span className="font-mono text-[10px] text-muted-foreground uppercase tracking-widest">Pricing</span>
                    <span className="font-sans text-lg font-bold text-foreground">
                      {product.price}
                    </span>
                  </div>

                  <Button asChild variant="default" className="w-full bg-primary text-primary-foreground rounded-lg font-mono font-bold uppercase tracking-widest text-[10px] h-12 shadow-md hover:shadow-lg transition-all">
                    <Link to="/ContactPage">
                      Request Technical Quote
                    </Link>
                  </Button>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}